module.exports = "img/list-open.6d0c059.png";